import { TaskRecurrence, TaskStatus, TaskType } from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const toDosTranslations = {
  // dashboard
  DASHBOARD_TITLE: 'Daily Dashboard',
  ADD_A_TODO: 'Add a To-Do',
  ADD_TO_DO: 'Add To-Do',
  NEXT_DAY: 'Next day',
  PREVIOUS_DAY: 'Previous day',
  EDIT_RECURRENCE: 'Edit Recurrence',
  NO_TASKS: 'No To-Dos to show',
  NO_TASKS_YET: 'Ready, set, go! The journey starts here',
  NO_TASKS_DESCRIPTION: 'Try using or updating filters to view more To-Do’s.',
  NO_TASKS_YET_DESCRIPTION:
    'Press that blue button at the top right of the page to create your first To-Do reoccurrence.',
  CHANGE_TEAM_MEMBERS: 'Change Team Members',
  CHANGE_TEAM_MEMBERS_DESCRIPTION: 'Update assigned Team Members',
  CHANGE_STATUS: 'Change Status',
  STATUS_CHANGED: 'Status changed',
  NEW_STATUS: 'New status',
  SELECT_NEW_STATUS: 'Select new status',
  CURRENT_STATUS: 'Current status',
  TEXT_AREA_PLACEHOLDER: 'Type here...',
  UNTIL_DUE: 'until Due',
  UNTIL_OVERDUE: 'until Overdue',
  ADD_COMMENT: 'Add a comment',
  ASTERISK: '* ',
  SNOOZE: 'Snooze',
  SNOOZED: 'Snoozed Todo',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  SNOOZE_DESCRIPTION:
    'Snoozing delays individual To-Do becoming Overdue by 1 hour.',
  DELETE: 'Delete this individual To-Do',
  DELETED: 'Deleted individual ToDo',
  DELETE_SHORT: 'Delete',
  DELETE_DESCRIPTION:
    'Deleting removes the individual To-Do occurrence from everyone’s To-Do list. This will not affect any past or future To-Do series. Deleting cannot be undone.',
  SORTED_BY: 'Sorted by',
  SORT_ASCENDING: 'Earliest date first',
  SORT_DESCENDING: 'Latest date first',
  ANYONE: 'Anyone',
  TEAM_MEMBERS: 'TEAM MEMBERS ASSIGNED',
  LOAD_MORE: '+ Load More',
  ANY_TEAM_MEMBERS: 'Any assigned team member',
  ONE_OFF: 'ONE-OFF',
  TEAM_TAG:
    'Each Team Member assigned will need to complete the To-Do individually',
  RESIDENT_TAG: 'This is a resident specific To-Do',
  HOME_TAG:
    'This is a non-resident To-Do that can be completed by any Team Member',
  SECOND_SIGNATURE: 'SECOND SIGNATURE',
  SECOND_SIGNATURE_TAG:
    'Requires a second signature when completing this To-Do',
  DAILY_LOG: 'DAILY LOG',
  DAILY_LOG_TAG: 'Requires creating a Daily Log after completing this To-Do',
  ONE_OFF_TAG: 'This is not a reoccurring To-Do',
  VIEW_ALL: 'View All',
  TODAYS_TODOS: "Today's To-Do's",
  TODOS_FOR_TODAY: "to-do's scheduled for today",
  NO_TODOS_TODAY: 'There are no To-Do’s scheduled for today.',
  CREATE_TODO: 'Create To-Do’s for your team and Service Users.',
  FIND_OUT_MORE_HERE: 'Find out more here.',
  FILTERS_SHOWING: 'Showing',
  FILTERS_APPLIED: 'based on filters',
  SEARCH_BY_TITLE: 'Type to search by title...',
  CREATE_A_TODO: 'Create a to-do list for your home and {{variable}}.',
  SEE_TODOS: 'See To-dos dashboard ',
  HERE: 'here',
  FROM: 'From',
  TO: 'To',

  // status translations
  [TaskStatus.completed]: 'Completed',
  [TaskStatus.skipped]: 'Skipped',
  [TaskStatus.pending]: 'Pending',
  [TaskStatus.missed]: 'Missed',

  // manager
  MANAGE_TODOS_TITLE: "Manage To Do's",
  COLUMN_ITEM: 'Item',
  COLUMN_TITLE: 'Title',
  COLUMN_TASK_TYPE: 'Type',
  COLUMN_TEAM_MEMBERS: 'Team Members',
  COLUMN_SERVICE_USERS: 'Service Users',
  COLUMN_FREQUENCY: 'Frequency',
  COLUMN_TIME: 'Time',
  COLUMN_START_DATE: 'Start Date',
  COLUMN_END_DATE: 'End Date',
  NO_PEOPLE: '-',
  TYPE: 'Type',
  FREQUENCY: 'Frequency',
  [TaskType.home]: 'Home',
  Residents: 'Resident',
  Tenants: 'Tenants',
  [TaskType.team]: 'Team',
  [TaskRecurrence.once]: 'One-off',
  [TaskRecurrence.daily]: 'Daily',
  [TaskRecurrence.weekly]: 'Weekly',
  [TaskRecurrence.biWeekly]: 'Bi-Weekly',
  [TaskRecurrence.monthly]: 'Monthly',
  OTHER: 'Other',
  DELETE_RECURRENCE: 'Deleting To-Do Series',
  DELETE_RECURRENCE_DESCRIPTION:
    'Please note that these changes will apply to future individual To-Do’s only. Deleting To-Do series cannot be undone.',
  TOAST_DELETE: 'Recurring task deleted successfully',
  NO_RESIDENTS_POPOVER: 'This is a non-{{variable}} To-Do.',
  NO_TEAM_MEMBERS_POPOVER: 'This is a {{variable}} specific To-Do',
  RECURRING_DISCLAIMER:
    "Some specific to-do items may not have been generated this far into the future. You can read more about how these individual to-do's are generated "
}

export const toDosConstants = getKeys(toDosTranslations)
